import React from 'react';
import { EyeIcon, HandHeartIcon, LinkIcon, MegaphoneIcon, ShieldIcon } from 'lucide-react';
import type { RippleCard } from '../utils/worldState';
interface RippleMapProps {
  cards: RippleCard[];
}
const ICONS: Record<RippleCard['id'], React.ReactNode> = {
  safety: <ShieldIcon size={16} aria-hidden="true" data-id="element-36" data-mp="358ci270kombv" />,
  dignity: <HandHeartIcon size={16} aria-hidden="true" data-id="element-37" data-mp="306eux1p1x7dn" />,
  connection: <LinkIcon size={16} aria-hidden="true" data-id="element-38" data-mp="2w5l3vzgbbcgj" />,
  accountability: <MegaphoneIcon size={16} aria-hidden="true" data-id="element-39" data-mp="2w75xnmusyrdc" />,
  clarity: <EyeIcon size={16} aria-hidden="true" data-id="element-40" data-mp="2reuyim7vz9lu" />
};
export function RippleMap({
  cards
}: RippleMapProps) {
  return <div className="relative" data-id="element-41" data-mp="2mh37duf2frip">
      <svg className="pointer-events-none absolute inset-x-0 top-0 hidden h-10 w-full lg:block" viewBox="0 0 1000 40" preserveAspectRatio="none" aria-hidden="true" data-id="element-42" data-mp="2mgbewsgrm9wn">
        <path d="M0 20 C100 4 200 36 300 20 S500 4 600 20 S800 36 1000 20" stroke="#2AA3B4" strokeWidth="10" fill="none" data-id="element-43" data-mp="2cjyhbji3nbwm" />
        <path className="anim-flow" d="M0 20 C100 4 200 36 300 20 S500 4 600 20 S800 36 1000 20" stroke="#F8F2E6" strokeWidth="2.5" fill="none" data-id="element-44" data-mp="3r9ouxrkyqcsp" />
      </svg>
      <div className="pointer-events-none absolute bottom-4 left-[19px] top-4 w-2 rounded-full bg-[#4E8C86] lg:hidden" aria-hidden="true" data-id="element-45" data-mp="3hc10z3v6l9bl" />
      <ul className="relative grid gap-4 lg:grid-cols-5" data-id="element-46" data-mp="3mb57tnumuuyr">
        {cards.map(card => <li key={card.id} className="relative pl-12 lg:pl-0 lg:pt-12" data-id="element-47" data-mp="dw3miipzlf7g">
            <span className="absolute left-2 top-5 flex h-8 w-8 items-center justify-center rounded-full border-4 border-cream bg-teal text-cream lg:left-1/2 lg:top-1 lg:-translate-x-1/2" aria-hidden="true" data-id="element-48" data-mp="iu59vfug40oq">
              {ICONS[card.id]}
            </span>
            <div className="flex h-full flex-col rounded-2xl border border-line bg-paper p-5 hc-strong" data-id="element-49" data-mp="2pk3bhucgia4h">
              <h3 className="font-display text-xl font-semibold text-forest" data-id="element-50" data-mp="2tmzo94fbfc0i">{card.title}</h3>
              <ul className="mt-2 flex flex-col gap-2" data-id="element-51" data-mp="103h950es0x7w">
                {card.lines.map(line => <li key={line} data-id="element-52" data-mp="v55yingnqiom">{line}</li>)}
              </ul>
            </div>
          </li>)}
      </ul>
    </div>;
}